import PropTypes from 'prop-types';
import React from 'react';
import { withTranslation } from 'react-i18next';
import Chart from 'react-apexcharts';
import { H4 } from '@blueprintjs/core';

class CoocSpecPopup extends React.PureComponent {

  state = {
     
  }


  render() {
        const { t,data,colloc } = this.props;

        if (data) {
            let xyTab=[];
            const keys=Object.keys(data).sort().filter(key => key !== '_global_');
            for (var i=0;i<keys.length;i++) {
                var key=keys[i];
                xyTab.push({x:key,y:data[key]});
            }
           // prep data for the chart
            const series = [{
                name:t('specificity'),
                data:xyTab
            }];
            const options = {
                chart: {
                type: 'bar',
                height: 350
                },
                plotOptions: {
                    bar: {
                        columnWidth: '80%',
                    }
                },
                dataLabels: {
                    enabled: false,
                },
                yaxis: {
                    title: {
                        text: t('specificity'),
                    },
                    labels: {
                        formatter: function (y) {
                        return y.toFixed(0);
                        }
                    }
                },
                xaxis: {
                    type: 'text',
                    labels: {
                        rotate: -90
                    }
                }
            };

            return (
                <>
                   
                    <Chart options={options} series={series} type="bar" height={350} />
                    <br/>
                    <center><H4>{colloc}</H4></center>
                </>
               
            );
        } else {
            return (<></>)
        }
    }
}

CoocSpecPopup.propTypes = {
        // see prepCoocData for an example
        data: PropTypes.arrayOf(PropTypes.number),
        colloc : PropTypes.string
};

export default withTranslation()(CoocSpecPopup);
